// # interfaces
import { iPaymentCard } from '@/interfaces/payments';
// # models
import { SurveyModel } from '@/models';
// # policies
import { SurveyPolicy } from '@/policies';
// # services
import {
    auth,
    notifications,
    siteSettingsService,
} from '@/services';



(function (angular) {
    'use strict';

    angular.module('app')
        .controller('manageSurveyController', manageSurveyController);

    manageSurveyController.$inject = [
        '$uibModalInstance',
        '$rootScope',
        '$scope',
        '$window',
        '$q',
        'SurveysApi',
        'EventsApi',
        'surveyId',
        'Helpers',
        'confirmDialog',
        'thisSiteSettings',
        'thisUser',
        'Users',
        'CategoryTypesApi',
        'CategoriesApi',
        'PollsApi',
    ];

    function manageSurveyController(
        $uibModalInstance,
        $rootScope,
        $scope,
        $window,
        $q,
        SurveysApi,
        EventsApi,
        surveyId,
        Helpers,
        confirmDialog,
        thisSiteSettings,
        thisUser,
        Users,
        CategoryTypesApi,
        CategoriesApi,
        PollsApi,
    ) {
        const vm = this;
        const user = auth.user();


        // properties
        vm.thisSiteSettings = thisSiteSettings;
        vm.isLoading = false;
        vm.isLoadingMessage = '';
        vm.formErrors = {};
        vm.thisUser = $rootScope.thisUser;
        vm.categoryTypes = []; // each one with "categories" and "selectedCategoryId" array
        vm.createNewSurvey = (surveyId ? false : true);
        vm.survey = {
            categories: [],
            status: 'pending',
            startsAt: window.moment().toDate(),
            endsAt: window.moment().add(1, 'months').toDate(),
            options: [],
            options2: [],
        };
        vm.exportOptions = {};
        vm.statusOptions = [
            { label: 'Pending', value: 'pending' },
            { label: 'Approved', value: 'approved' },
            { label: 'Rejected', value: 'rejected' },
        ];
        vm.typeOptions = [
            { label: 'Survey', value: 'survey' },
        ];
        vm.permissionChecks = {
            canDelete: false,
            canManage: SurveyPolicy.canManage(user),
            canManageOptions: SurveyPolicy.canManageOptions(user, new SurveyModel(vm.survey)),
            canManageStatus: SurveyPolicy.canManageStatus(user),
            paymentRequired: SurveyPolicy.createPaymentRequired(user),
            canExportVoters: SurveyPolicy.canExportVoters(user),
            canExportVotes: SurveyPolicy.canExportVotes(user),
            canCreateEventSurveys: SurveyPolicy.canCreateEventSurveys(user),
        };
        vm.surveyOptionsTemplate = {
            value: {
                label: 'Option Name',
                type: 'string',
                placeholder: '',
            },
        };
        vm.statusOptions = [
            { label: 'Pending', value: 'pending' },
            { label: 'Approved', value: 'approved' },
            { label: 'Rejected', value: 'rejected' },
        ];
        vm.labels = {
            saveButton__update: 'Save',
            saveButton__create: vm.permissionChecks.paymentRequired ? `Purchase for ${thisSiteSettings.currency_symbol}${siteSettingsService.get('poll_charge_price')}` : 'Create',
        };
        vm.polls = [];

        // methods
        vm.close = $uibModalInstance.close;
        vm.getSurvey = getSurvey;
        vm.saveSurvey = saveSurvey;
        vm.deleteSurvey = deleteSurvey;
        vm.downloadExport = downloadExport;
        vm.selectAllExportOptions = selectAllExportOptions;
        vm.handleDescriptionChange = handleDescriptionChange;
        vm.getCategoryTypes = getCategoryTypes;
        vm.getCategories = getCategories;
        vm.setCategories = setCategories;
        vm.getPolls = getPolls();

        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getSurveys();
        getPolls();

        /**
         * Initialises controller values.
         *
         * @returns {Promise<void>}
         */
        async function bootstrap(): Promise<void> {
            //await getCategoryTypes();

            if (vm.createNewSurvey == false) {
                getSurvey();
            }


            $scope.$on('modal.closing', function (event, reason, closed) {
                if (!closed && !vm.forceClose) {
                    return event.preventDefault();
                }
            });
        }

        /**
         * Retrieves category types from the API
         *
         * @returns {Promise<void>}
         */
        function getCategoryTypes(): Promise<void> {
            return new Promise((resolve, reject) => {
                CategoryTypesApi.query(
                    { "categorizables[]": ['surveys'] },
                    async (response: any) => {
                        vm.categoryTypes = response;

                        await getCategories();
                        resolve();
                    },
                    reject,
                );
            });
        }

        /**
         * Retrieves categories from the API
         *
         * @returns {Promise<void>}
         */
        function getCategories(): Promise<void> {
            return new Promise((resolve, reject) => {
                CategoriesApi.query(response => {
                    vm.categories = response;
                    //console.log(vm.categories);

                    angular.forEach(vm.categoryTypes, categoryType => {
                        const cats = vm.categories.filter(cat => {
                            return cat.type_id === categoryType.id;
                        });

                        categoryType.categories = cats;
                    });
                    resolve();
                }, reject);
            });
        }

        /**
         * Retrieves events
         *
         * @return {void}
         */
        function getEvents() {
            const date = new Date();
            date.setDate(date.getDate() - 30);

            EventsApi.get({
                status: 'approved',
                starts_at_from: date,
            }, response => {
                vm.events = response.data;
            });
        }

        /**
         * Retrieves surveys
         *
         * @return {void}
         */
         function getSurveys() {
            SurveysApi.get({
                status: 'approved',
            }, response => {
                vm.surveys = response.data;

                vm.currentSurveyIndex = vm.surveys.indexOf(vm.surveys.find(o => o.id === vm.survey.id));

                vm.surveys = vm.surveys.filter(function(value, index, arr) {
                    if (index != vm.currentSurveyIndex) {
                        return true;
                    } else {
                        return false;
                    }
                });
            });
        }

        /**
         * Retrieves the survey from the API and assigns to the scope
         * @return {void}
         */
        function getSurvey() {
            //console.log('get');
            vm.isLoading = true;
            vm.isLoadingMessage = 'Loading Survey...';

            SurveysApi.get({
                id: surveyId,
                include_private: true,
            }, response => {


                let dat = {
                    startsAt: (response.data.starts_at ? window.moment(response.data.starts_at).toDate() : window.moment().toDate()),
                    endsAt: (response.data.starts_at ? window.moment(response.data.ends_at).toDate() : window.moment().toDate()),
                    options: response.data.questions.map(option => {
                        return { value: option.question };
                    }),
                    options2: [],
                };

                if (response.data.polls !== null) {
                    if (Array.isArray(response.data.polls)) {
                        angular.forEach(response.data.polls, function (pollRecord) {
                            dat.options2 = pollRecord.poll.poll_options.map(option => {
                                return { value: option.value };
                            });
                        });
                    } else {
                        dat.options2 = response.data.polls.poll.poll_options.map(option => {
                            return { value: option.value };
                        });
                    }
                }

                vm.survey = angular.merge(dat, response.data);

                //vm.survey.categories = vm.survey.categories.map(function(d) { return d['id']; });

                //console.log('get2');
                const surveyModel = new SurveyModel(vm.survey);
                vm.permissionChecks.canManage = SurveyPolicy.canManage(auth.user(), surveyModel);
                vm.permissionChecks.canManageOptions = SurveyPolicy.canManageOptions(user, surveyModel);
                vm.permissionChecks.canDelete = SurveyPolicy.canDelete(auth.user(), surveyModel);
                vm.permissionChecks.canExportVotes = SurveyPolicy.canExportVotes(auth.user(), surveyModel);

                //getEvents();
                getPolls(vm.survey.polls);
                vm.isLoading = false;
            }, error => {
                vm.isLoading = false;
                vm.forceClose = true;
                vm.dismiss();
            });
        }

        /**
         * Handles UI to collect card details.
         *
         * @returns {Promise<null | iPaymentCard>}
         */
        function handlePaymentIfRequired(): Promise<null | iPaymentCard> {
            return new Promise((resolve, reject) => {
                if (!vm.permissionChecks.paymentRequired) {
                    return resolve(null);
                }

                Users.manageCard()
                    .result
                    .then(resolve, reject);
            });
        }

        /**
         * Saves or updates the survey to the API
         * @return {void}
         */
        function saveSurvey() {
            handlePaymentIfRequired()
                .then((card: null | iPaymentCard) => {
                    if (card && card.stripe_id) {
                        vm.survey.stripe_id = card.stripe_id;
                    }

                    const funcName = (vm.createNewSurvey ? 'save' : 'update');

                    vm.isLoadingMessage = (vm.createNewSurvey ? 'Creating Survey...' : 'Saving Survey...');
                    vm.isLoading = true;

                    // transform start/end dates
                    vm.survey.starts_at = window.moment(vm.survey.startsAt).startOf('day').format(Helpers.isoFormat);
                    vm.survey.ends_at = window.moment(vm.survey.endsAt).endOf('day').format(Helpers.isoFormat);

                    if (vm.survey.is_private === undefined) {
                        vm.survey.is_private = false;
                    }

                    SurveysApi[funcName](
                        vm.survey,
                        response => {
                            vm.isLoading = false;

                            notifications.display({
                                message: vm.permissionChecks.paymentRequired ? 'Your payment was successful.' : '',
                                theme: 'success',
                                title: vm.surveyCreated ? 'Survey Created' : 'Survey Saved',
                            });

                            $uibModalInstance.close(response.data);
                        },
                        error => {
                            vm.formErrors = error.data;
                            vm.isLoading = false;
                        })
                        .suppressValidationAlerts();
                })
                .catch(error => {
                    notifications.display({
                        message: error.message || 'There was a problem taking your card details.',
                        title: 'Error',
                    });
                });
        }

        /**
         * Deletes this survey after confirmation
         * @return {void}
         */
        function deleteSurvey() {
            confirmDialog('Are you sure you want to delete this survey?').result.then(function (confirm) {
                if (confirm) {
                    vm.isLoadingMessage = 'Deleting...';
                    vm.isLoading = true;

                    SurveysApi.delete({
                        id: vm.survey.id
                    }, function handleDeleteSurveyResponse() {
                        vm.forceClose = true;
                        $uibModalInstance.dismiss('deleted');
                        vm.isLoading = false;

                        notifications.display({
                            theme: 'success',
                            title: 'Survey deleted',
                            message: '',
                        });

                        $window.location.reload();
                    }, function handleDeleteSurveyError(err) {
                        err = err || '';
                        vm.isLoading = false;

                        notifications.display({
                            title: 'Error while attempting to save',
                            message: err.toString(),
                        });
                    });
                }
            });
        }

        /**
         * Selectes all export options
         * @return {void}
         */
        function selectAllExportOptions() {
            vm.exportOptions = {};

            angular.forEach(vm.survey.options, function (option) {
                vm.exportOptions[option.value] = true;
            });
        }

        /**
         * Navigates to the export survey options route, passing the selected options as parameters
         * @return {void}
         */
        function downloadExport() {
            var url = '/api/surveys/' + vm.survey.id + '/export-users?';

            angular.forEach(vm.exportOptions, function (optionVal, optionName) {
                if (optionVal) {
                    url += 'options[]=' + optionName + '&';
                }
            });

            window.location.href = url.slice(0, -1);
        }

        /**
         * Replaces selected categories on the resources object.
         *
         * @param {number[]} categoryIds
         * @returns {void}
         */
        function setCategories(categoryIds: number[]): void {
            vm.survey.categories = categoryIds;
            $scope.$apply();
        }

        /**
         * Updates the event description
         *
         * @param {string} description html
         * @returns {void}
         */
        function handleDescriptionChange(description) {
            vm.survey.description = description;
        }

        /**
         * Retrieves polls
         *
         * @return {void}
         */
        function getPolls(surveyPolls = null) {
            PollsApi.get({
                status: 'approved',
                include_dont_show_on_polls: true,
            }, response => {
                vm.polls = response.data;
                if (surveyPolls != null) {
                    let pollObject = {};
                    //loop over each poll
                    angular.forEach(vm.polls, function (poll) {
                        //see if the key of that poll exists in the survey polls
                        if (surveyPolls.some(e => e.poll_id === poll.id)) {
                            // eslint-disable-next-line no-param-reassign
                            poll.checked = true;
                            pollObject[poll.id] = true;
                        }
                    });
                    vm.survey.polls = pollObject;
                }
            });
        }

        // init
        bootstrap();
    }
}(angular));
